<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h3 class="mt-3">Nuevo perfil metálico</h3>
        <NewProfileForm></NewProfileForm>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue"
import NewProfileForm from "@/components/Admin/Profile/NewProfileFormComponent.vue"
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue"
export default{
    data(){
        return{

        }
    },
    methods:{

    },
    components:{
        NavBarAdmin,
        NewProfileForm,
        FooterAdmin,
    }
}
</script>
<style scoped>

</style>